<script setup>
import { useI18n } from 'vue-i18n';

/**
 * SuperTVGo: tabela de contas UniTV e IPTV (`/admin/contas`, mantida pelo app
 * da SuperTVGo e sincronizada todo dia às 7h) embutida aqui dentro — pedido do
 * usuário, 2026-09-20. Servida no MESMO domínio (bloco `chat.` do Caddyfile
 * do repo supertvgo), por isso o `src` é caminho relativo, nunca URL
 * absoluta. Diferente de `SupertvgoRelatorios.vue`, `/admin/contas` é pública
 * (sem token/Basic Auth — pedido do usuário, 2026-09-22), então não depende
 * de nenhum cookie pra abrir dentro do iframe.
 */
const URL_PAINEL = window.SUPERTVGO_CONTAS_URL || '/admin/contas';

const { t } = useI18n();
</script>

<template>
  <div class="w-full h-full bg-n-surface-1">
    <iframe
      :src="URL_PAINEL"
      :title="t('SIDEBAR.SUPERTVGO_CONTAS')"
      class="w-full h-full border-0"
    />
  </div>
</template>
